import { render } from "./EmailReset.vue?vue&type=template&id=1bdca5df&scoped=true"
import script from "./EmailReset.vue?vue&type=script&lang=js"
export * from "./EmailReset.vue?vue&type=script&lang=js"

import "./EmailReset.vue?vue&type=style&index=0&id=1bdca5df&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bdca5df"]])

export default __exports__